module.exports = __webpack_public_path__ + "img/cast_logo_simple.38efe2ba.svg";